import { ChackImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetRequest =
  ({ callback, status, page, categorize_by = "none", rowsPerPage }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.requests.get;
      const body = {
        status: status,
      };

      body.page = page;
      if (rowsPerPage) {
        body.rowsPerPage = rowsPerPage;
      }

      if (categorize_by !== "none") {
        // "year" / "month" / "week"
        body.categorize_by = categorize_by;
      }

      const response = await PostFunction({
        data: body,
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const SearchRequests =
  ({ callback, search }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.requests.search;
      const data = {
        search,
      };

      const response = await PostFunction({
        data,
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

// export const ManageCountries =
//   ({ callback, values, editMode }) =>
//   async (dispatch, getState) => {
//     try {
//       const noGroup =
//         CheckDataIfExit(values?.group_id) === false || values?.group_id === "-";

//       dispatch(setLoading(true));
//       var bodyFormData = new FormData();
//       if (editMode) {
//         bodyFormData.append("id", values?.id);
//       }
//       if (CheckDataIfExit(values?.name)) {
//         bodyFormData.append("name", values?.name);
//       }
//       if (CheckDataIfExit(values?.statistics)) {
//         bodyFormData.append("statistics", values?.statistics);
//       }
//       if (CheckDataIfExit(values?.visa_type)) {
//         if (noGroup) {
//           let visa_type_array = [];
//           for (let i = 0; i < values?.visa_type?.length; i++) {
//             visa_type_array.push(values?.visa_type[i].id);
//           }
//           bodyFormData.append("visa_type", JSON.stringify(visa_type_array));
//         }
//       }
//       // console.log({ grp_id: values?.group_id });
//       if (CheckDataIfExit(values?.group_id) && values?.group_id !== "-") {
//         bodyFormData.append("group_id", values?.group_id);
//       }
//       if (
//         values?.image &&
//         values?.image != null &&
//         values?.image != undefined &&
//         ChackImageIsFile({ data: values?.image, IsBoolean: true })
//       ) {
//         bodyFormData.append("image", values?.image);
//       } else if (editMode && !values?.image) {
//         bodyFormData.append("image", "");
//       }
//       const response = await PostFunction({
//         data: bodyFormData,
//         Route: editMode ? UrlApi.country.edit : UrlApi.country.add,
//         showalert: true,
//         state: getState,
//         isMultipart: true,
//         dispatch: dispatch,
//       });
//       dispatch(setLoading(false));
//       callback(response);
//     } catch (err) {
//       console.log(err);
//       dispatch(setLoading(false));
//       callback(false);
//     }
//   };

export const EditRequestReviews =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          id: id,
          [nameFailed]: dataFailed,
        };
      }
      const response = await PostFunction({
        data,
        Route: UrlApi.request_reviews.edit,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const DeleteRequestReviews =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data = {
        idsrequestreviews: Array.isArray(id) ? id : [id],
      };
      const response = await PostFunction({
        data,
        Route: UrlApi.request_reviews.delete,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
